// @flow
import clsx from 'clsx';

import { Base, type BaseProps } from '@gandi/ui';

import styles from './PillButton.scss';

export function PillButton({
  active,
  ...props
}: {
  ...$Exact<BaseProps>,
  active?: boolean,
  ...
}): React.MixedElement {
  return (
    <Base
      {...props}
      tagName="button"
      type="button"
      className={clsx(styles.root, { [styles.active]: active })}
    />
  );
}
